<template lang="pug">
  .services-accordion
    template(v-for="service in mappedServices" :key="service._id")
      .fold( :id="service._id")
        .head.kapra-neue(@click="clickHead(service._id)")
          p.name.xs-f-large.cta-color-2 {{ getServiceName(service) }}
          .right-wrap
            a.cta-color-4.kapra-neue.xs-f-medium.max-at-tweak(:href="bookUrl" @click.stop.prevent="bookNowHandler(service)") Book now
            .divider.ml-100m.mr-100m.ui-color-8-bg
            span.arrow.icon-caret-down.xs-f-xxsmall.max-at-tweak.ml-100m(:class="{'opened': opened == service._id}")
              span.ada-tooltip caret down icon
        transition-expand
          .body(v-if="opened == service._id")
            .images.xs-12.md-4
              ServiceImageCarousel(:images="service.moreDetails.images")
            .info.xs-12.md-8
              .time-price.cta-color-4.bold.xs-f-small.max-at-tweak.mb-100m
                .pill(v-if="service.hcbPrice") {{ $currencyShort(service.hcbPrice) }}
                .pill {{ service.totalTimeRequired }}m
              p.description.xs-f-small.max-at-tweak.mb-100m {{ service.description }}
              .cta.mb-150m
                a.mr-btn.btn-block(:href="bookUrl" @click.prevent="bookNowHandler(service)") Book service
              .good-bad
                .good.xs-12.md-5(v-if="service.moreDetails?.list")
                  p.cta-color-4.xs-f-medium.max-at-tweak.bold Good for
                  .bullet(v-for="good in service.moreDetails?.list")
                    mr-icon(name="circle-arrow" :fill="false")
                    p {{ good }}
                template(v-if="service.moreDetails?.seccondList?.length")
                  .divider.xs-12.md-2
                    .line
                  .bad.xs-12.md-5
                    p.cta-color-4.xs-f-medium.max-at-tweak.bold Not good for
                    .bullet(v-for="bad in service.moreDetails?.seccondList")
                      mr-icon(name="circle-arrow" :fill="false")
                      p {{ bad }}
</template>
<script>
  import { mapActions, mapGetters, mapState } from 'vuex';
  import vueColorbarSvc from '@services/vueColorbarSvc';
  import ServiceImageCarousel from './ServicesCarousel/';

  export default {
    name: "ServicesAccordion",

    components: {
      ServiceImageCarousel,
    },

    props: {
      ids: {
        type: String,
        default: ''
      }
    },

    data() {
      return {
        services: [],
        opened: null,
        serviceCodeMap: {}
      };
    },

    computed: {
      ...mapGetters('hairColorBarBooking', ['servicesAfterConsultationLogic']),
      ...mapState('global', ['windowData']),

      breakpoint() {
        return this.windowData.breakpoint;
      },


      idsToShow() {
        return this.ids.split(',');
      },

      customerClosestLocation() {
        return this.cdata?.locationContext?.closestColorbar;
      },

      bookUrl() {
        let url = '/colorbar/locations';
        if (this.customerClosestLocation) {
          url = `/colorbar/booking/${this.customerClosestLocation}/services`;
        }

        return url;
      },


      mappedServices() {
        return this.services.map(s => {
          const mapped = this.mapService(s);

          if (mapped) {
            s.code = mapped.code;
            s.totalTimeRequired = mapped.totalTimeRequired;
            s.hcbPrice = mapped.price;
          }

          return s;
        });
      }


    },

    async mounted() {
      if (this.customerClosestLocation) {
        await this.getLocation(this.customerClosestLocation);
      }

      const { data } = await vueColorbarSvc.getServicesList({ ids: this.idsToShow });
      this.services = data;
      if (this.services?.length) {
        this.opened = this.services[0]._id;
      }
    },

    methods: {
      ...mapActions('hairColorBarBooking', ['getLocation']),

      mapService(service) {
        const mapped = this.servicesAfterConsultationLogic.find(s => s.code.includes(service.code));

        return mapped;
      },

      clickHead(_id) {
        if (this.opened == _id) {
          this.opened = null;
        } else {
          this.opened = _id;
          if (this.breakpoint == 'mobile') {
            setTimeout(() => {
              const el = document.getElementById(_id);
              el.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 700);
          }
        }
      },

      getServiceName(service) {
        return service.displayName || service.name;
      },

      bookNowHandler(service) {
        let code = service.code;
        if (!this.customerClosestLocation) {
          code += '_consult';
        }
        this.$cookies.set('selected_service', code);
        let url = this.bookUrl;
        this.trackMREventAndRedirect(`Services Landing Pages - Book Service clicked - ${service.code}`, url);
      }

    }
  };
</script>

<style scoped lang="stylus">
  .services-accordion
    max-width 1300px
    margin 0 auto
    display flex
    flex-direction column
    width 100%
    align-items center

    .fold
      width 100%
      display flex
      flex-direction column
      border-radius 14px 14px 0 0
      box-shadow 0px -10px 60px 0px rgba(0, 0, 0, 0.1)
      overflow hidden
      cursor pointer

      .head
        display flex
        justify-content space-between
        align-items center
        padding 0.5em 2em

        .right-wrap
          display flex
          justify-content space-between
          align-items center
          height 20px

          a
            text-wrap nowrap

          .arrow
            transition 0.4s
            &.opened
              transform rotate(180deg)

          .divider
            height 100%
            width 2px

        .arrow::before
          color cta-color-1
          font-weight bolder

      .body
        display flex
        position relative
        gap 3em
        padding 2em

        @media mq-tablet-less
          flex-direction column
          padding 2em
          gap 0

        .info
          max-width @css{min(50vw, 650px)}
          @media mq-tablet-less
            max-width unset

          .time-price
            display flex
            justify-content flex-start
            align-items center
            gap 1em

          .pill
            border-radius 60px
            background-color ui-color-3
            padding 0.5em 2em

          .good-bad
            display flex
            justify-content space-between
            @media mq-mobile
              flex-direction column

            .good,.bad
              display flex
              flex-direction column
              gap 1em

              .bullet
                display flex
                gap 1em
                align-items center

                p
                  width fit-content

                svg.mr-icon
                  color cta-color-4
                  width 2em

            .divider
              display flex
              justify-content center
              align-items center

              .line
                background-color ui-color-3
                width 2px
                height 100%
                @media mq-mobile
                  width 100%
                  height 2px
                  margin 2em 0

</style>
<style lang="stylus">
  .services-accordion
    .fold
      .body
        .images
          .carousel-wrap-inner
            width 100%

</style>